import theme from '@barracuda-internal/bds-core/dist/styles/themes/baseMui'

export default {
  root: {
    backgroundColor: theme.palette.background.paper
  }
}
